<div class="absolute w-full py-1 px-4 lg:px-10 flex justify-between shadow-md bg-white z-30">
    <!-- Logo em forma de texto -->
    <div class="flex items-center cursor-pointer pl-8 lg:pl-0" (click)="onClickLogo()">
      <img src="assets/img/Logo.png" alt="Westhetics" class="w-1/2 lg:w-1/3">
    </div>
    <div class="flex items-center gap-4 text-nowrap">
      <!-- Seletor de clínica ativa -->
      <div class="w-48 hidden sm:block">
        <app-clinic-switcher></app-clinic-switcher>
      </div>
      <span class="font-medium mr-1">{{username}}</span>
      <button class="w-full py-2 px-4 text-left hover:bg-neutral-100" (click)="logout()">Sair</button>
    </div>
  </div>
  